// styles
//import '../custom/css/example.css';
// import '../../templates/vostok/fonts/stylesheet.css';
// import '../../templates/vostok/icomoon/style.css';
// import '../../templates/vostok/style/plugin.css';
// import '../../templates/vostok/style/style.css';
// import '../../templates/vostok/style/ext_style.css';
// import '../../templates/vostok/style/responsive.css';


//import {$,jQuery} from 'jquery';

// export for others scripts to use
// window.$ = $;
// window.jQuery = jQuery;
// js
//import '../custom/js/hello_webpack';



// import '../../templates/vostok/js/webpack/main.js';
// import '../../templates/vostok/js/webpack/groups.js';
// import '../../templates/vostok/js/webpack/object_list.js';
// import '../../templates/vostok/js/webpack/data-map.js';
// import '../../templates/vostok/js/webpack/data-map.js';
// "/js/groups.js"
// "/js/object_list.js"
// "/js/data-map.js"
// "/js/ext_main.js"
window.mixins = [];
//import location from '../custom/vue/components/location/template';
//import userfield from '../custom/vue/components/user-field/template';
// vue
//import '../custom/vue/catalog';
import '../custom/vue/main';